import type { Product } from './ProductCard';

interface NutritionPanelProps {
  product: Product;
}

export default function NutritionPanel({ product }: NutritionPanelProps) {
  const { nutrition } = product;

  const rows = [
    { label: 'Calories', value: `${nutrition.calories} kcal`, bold: true },
    { label: 'Protein', value: nutrition.protein },
    { label: 'Total Carbohydrates', value: nutrition.carbs },
    { label: 'Dietary Fiber', value: nutrition.fiber, indent: true },
    { label: 'Total Sugars', value: nutrition.sugar, indent: true },
    { label: 'Total Fat', value: nutrition.fat },
    { label: 'Sodium', value: nutrition.sodium },
    ...(nutrition.vitaminC ? [{ label: 'Vitamin C', value: nutrition.vitaminC }] : []),
    ...(nutrition.potassium ? [{ label: 'Potassium', value: nutrition.potassium }] : []),
    ...(nutrition.iron ? [{ label: 'Iron', value: nutrition.iron }] : []),
    ...(nutrition.calcium ? [{ label: 'Calcium', value: nutrition.calcium }] : []),
  ];

  return (
    <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden">
      <div className="bg-gray-900 px-6 py-4">
        <h3 className="text-white font-bold text-lg tracking-wide">Nutrition Facts</h3>
        <p className="text-gray-400 text-sm mt-1">Serving Size: {nutrition.servingSize}</p>
      </div>
      <div className="divide-y divide-gray-100">
        {rows.map((row, i) => (
          <div
            key={i}
            className={`flex items-center justify-between px-6 py-3 ${row.bold ? 'bg-amber-50' : ''}`}
          >
            <span
              className={`text-sm ${row.indent ? 'pl-4 text-gray-500' : 'text-gray-700'} ${row.bold ? 'font-bold text-gray-900' : ''}`}
            >
              {row.label}
            </span>
            <span className={`text-sm font-semibold ${row.bold ? 'text-amber-700 text-base' : 'text-gray-800'}`}>
              {row.value}
            </span>
          </div>
        ))}
      </div>
      <div className="px-6 py-4 bg-gray-50 border-t border-gray-200">
        <p className="text-xs text-gray-400 leading-relaxed">
          * Percent Daily Values are based on a 2,000 calorie diet. Values may vary slightly depending on batch and season.
        </p>
      </div>
    </div>
  );
}
